import React, { useEffect, useState } from "react";
import { apiGetOrders, apiUpdateOrderStatus } from "../../api";

const STATUSES = ["Pending", "Confirmed", "Shipped", "Delivered", "Cancelled"];

const statusColor = (s) => ({
  Pending: "bg-amber-100 text-amber-700",
  Confirmed: "bg-blue-100 text-blue-700",
  Shipped: "bg-purple-100 text-purple-700",
  Delivered: "bg-green-100 text-green-700",
  Cancelled: "bg-red-100 text-red-700",
}[s] || "bg-neutral-100 text-neutral-700");

const AdminOrders = () => {
  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const load = () => apiGetOrders().then(setOrders).catch(() => setOrders([]));
  useEffect(() => { load(); }, []);

  const changeStatus = async (id, status) => {
    await apiUpdateOrderStatus(id, status);
    load();
  };

  return (
    <div>
      <h1 className="font-serif text-3xl text-neutral-900 mb-6">Orders ({orders.length})</h1>
      {orders.length === 0 ? (
        <p className="text-neutral-500">No orders yet.</p>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => (
            <div key={o.id} className="bg-white rounded-sm border border-neutral-200 overflow-hidden">
              <div className="flex flex-wrap items-center justify-between gap-3 p-4">
                <div className="flex items-center gap-4">
                  <button onClick={() => setExpanded(expanded === o.id ? null : o.id)} className="text-left">
                    <p className="font-semibold text-neutral-900">{o.orderNumber}</p>
                    <p className="text-xs text-neutral-500">{o.customer?.name} • {o.customer?.phone}</p>
                  </button>
                  {o.whatsappOptIn && <span className="text-xs text-[#25D366] font-medium">WhatsApp ✓</span>}
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-bold text-neutral-900">₹{o.total.toLocaleString("en-IN")}</span>
                  <span className={`px-2.5 py-1 rounded-full text-xs ${statusColor(o.status)}`}>{o.status}</span>
                  <select value={o.status} onChange={(e) => changeStatus(o.id, e.target.value)}
                    className="border border-neutral-300 rounded-sm px-2 py-1.5 text-sm focus:outline-none">
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
              </div>
              {expanded === o.id && (
                <div className="border-t border-neutral-100 bg-neutral-50 p-4 text-sm">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <p className="font-medium text-neutral-700 mb-1">Items</p>
                      <ul className="space-y-1 text-neutral-600">
                        {o.items.map((it, i) => (
                          <li key={i}>{it.name} ({it.size}) × {it.qty} — ₹{(it.price * it.qty).toLocaleString("en-IN")}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <p className="font-medium text-neutral-700 mb-1">Delivery</p>
                      <p className="text-neutral-600">{o.customer?.address}, {o.customer?.city} {o.customer?.pincode}</p>
                      <p className="text-neutral-600 mt-1">Payment: {o.paymentMethod?.toUpperCase()}</p>
                      {o.paymentMethod === "upi" && (
                        <p className="text-neutral-600">
                          UTR: {o.upiTransactionId || <span className="text-amber-600">Not provided — verify in your UPI app</span>}
                        </p>
                      )}
                      <p className="text-neutral-600">Subtotal ₹{o.subtotal} • Disc ₹{o.discount} • Ship ₹{o.shipping}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminOrders;
